<template>
	<div class="detalhes-estorno-item">
		<v-row>
			<v-col cols="12">
				<label-personalizado class="label titulo" nome-campo="Item"></label-personalizado>
				<texto-tooltip :texto="itemSelecionado.descricao" :tamanho-maximo="300"></texto-tooltip>
			</v-col>
		</v-row>
		<v-divider class="divider mb-2 mt-2"></v-divider>
		<v-row>
			<v-col cols="12">
				<label-personalizado class="label titulo" nome-campo="Justificativa"></label-personalizado>
				<div class="py-3">{{ data.justificativa }}</div>
			</v-col>
		</v-row>
		<v-divider class="divider mb-2 mt-2"></v-divider>
		<label-personalizado class="label titulo" nome-campo="Saldos Anteriores"></label-personalizado>
		<v-row>
			<v-col cols="4">
				<label-personalizado class="label" nome-campo="Saldo Ata"></label-personalizado>
				<div class="py-3">{{ data.saldoAnteriorAta }}</div>
			</v-col>
			<v-col cols="4">
				<label-personalizado class="label" nome-campo="Saldo Órgão"></label-personalizado>
				<div class="py-3">{{ data.saldoAnteriorOrgao }}</div>
			</v-col>
			<v-col cols="4">
				<label-personalizado class="label" nome-campo="Qtde. Solicitada"></label-personalizado>
				<div class="py-3">{{ data.saldoAnteriorQtdSolicitada }}</div>
			</v-col>
		</v-row>
		<v-divider class="divider mb-2 mt-2"></v-divider>
		<label-personalizado class="label titulo" nome-campo="Saldos Atualizados"></label-personalizado>
		<v-row>
			<v-col cols="4">
				<label-personalizado class="label" nome-campo="Qtde. Estornada"></label-personalizado>
				<div class="py-3">{{ data.quantidadeEstornada }}</div>
			</v-col>
			<v-col cols="4">
				<label-personalizado class="label" nome-campo="Saldo Ata"></label-personalizado>
				<div class="py-3">{{ data.saldoAtualAta }}</div>
			</v-col>
			<v-col cols="4">
				<label-personalizado class="label" nome-campo="Saldo Órgão"></label-personalizado>
				<div class="py-3">{{ data.saldoAtualOrgao }}</div>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { actionTypes } from '@/core/constants'
import FiltroHistoricoEstornoItemPedidoInput from '@/core/apiclient/item-pedido/estorno/models/FiltroHistoricoEstornoItemPedidoInput'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'

export default {
	name: 'historico-estornar-item-pedido',
	components: { LabelPersonalizado },
	props: {
		itemSelecionado: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			data: {},
		}
	},
	async mounted() {
		await this.carregarDetalhesEstornoItemPedido()
	},
	methods: {
		async carregarDetalhesEstornoItemPedido() {
			this.data = await this.$store.dispatch(
				actionTypes.ITEM_PEDIDO.ESTORNO.DETALHES.BUSCAR,
				new FiltroHistoricoEstornoItemPedidoInput(this.itemSelecionado.idItemPedido),
			)
		},
	},
}
</script>
<style lang="stylus" scoped>
.detalhes-estorno-item {
	.titulo {
		color var(--v-primary-base)
	}
	.label {
		font-size 14px !important
	}
	.divider {
		position: relative;
		right: 22px;
		width: 108% !important;
		max-width: none !important;
	}
}
</style>
